/**
 * DevExtreme (esm/__internal/ui/collection/edit.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import CollectionWidgetEdit from "../../../ui/collection/ui.collection_widget.edit";
import CollectionWidgetBase from "./base";
var TypedCollectionWidget = CollectionWidgetEdit;
export default TypedCollectionWidget;
